import React, { Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Shipment } from 'services/action';
import { Skeletons } from 'ui/components/skeleton';

import { Page } from 'ui/components';
import {
  InformationOrder,
  InformationShipment,
  ContactInformation,
  InformationItems,
  InformationPricing,
  InformationLatest,
  Log,
  Document,
  Action,
  ManifestList,
} from './component/detail';
import _ from 'underscore';

const Maps = React.lazy(() => import('ui/components/mapbox/map.shipment'));

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Shipment.Show']
  );
  const [data, setData] = React.useState(null);
  const [privilege, setPrivilege] = React.useState(null);

  const $onLoad = async (id) => {
    const req = await Dispatch(Shipment.$show(id));

    if (req?.message === 'success') {
      setData(req?.data);
    }
  };

  const $getPriviledge = async () => {
    const pricing = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });

    setPrivilege(pricing);
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, [match]);

  if (StateLoading) {
    return (
      <Page className="col-lg-10 col-md-10 bordered">
        <Skeletons height="100px" width="100%" />
        <Page.Body className="bg-white padding">
          <div className="mb-3">
            <Skeletons height="50px" width="100%" />
          </div>
          <div className="mb-3">
            <Skeletons height="50px" width="100%" />
          </div>
          <div className="mb-3">
            <Skeletons height="50px" width="100%" />
          </div>
          <div className="mb-3">
            <Skeletons height="50px" width="100%" />
          </div>
        </Page.Body>
      </Page>
    );
  }

  return (
    <Page className="col-lg-10 col-md-10 bordered">
      <Page.Header
        pretitle="Shipment"
        title={data?.shipment?.code}
        status={data?.document_status}
        backTo="/order/shipment"
      >
        <Action data={data} onSubmit={() => $onLoad(match?.params?.id)} />
      </Page.Header>

      <Page.Body className="bg-white padding mt-3 mt-md-0">
        <div className="row m-0">
          <div className="col-md-9">
            <div className="row">
              <div className="col-md-4">
                <InformationOrder data={data} />
              </div>
              <div className="col-md-4">
                <InformationShipment data={data} />
              </div>
              <div className="col-md-4">
                <InformationLatest data={data} />
              </div>
            </div>

            <div className="mb-3">
              <Suspense fallback={<div>Loading...</div>}>
                <Maps data={data} className="map-container rounded" />
              </Suspense>
            </div>

            <div className="row">
              {data?.shipment?.origin && (
                <div className="col-md-6">
                  <ContactInformation
                    data={data?.shipment?.origin}
                    title="Origin"
                    id="sender"
                  />
                </div>
              )}
              {data?.shipment?.destination && (
                <div className="col-md-6">
                  <ContactInformation
                    data={data?.shipment?.destination}
                    title="Destinasi"
                    id="recipient"
                  />
                </div>
              )}
            </div>

            {data?.shipment?.items && (
              <InformationItems data={data?.shipment?.items} />
            )}

            {(!Session?.privileges || privilege?.pricing) && (
              <InformationPricing data={data} />
            )}

            <ManifestList delivery={data} shipment={data?.shipment} />
          </div>
          <div className="col-md-3">
            <Document
              id={data?.shipment?.id}
              status={data?.document_status}
              clientId={data?.order?.client?.id}
              privilege={
                !Session?.privileges || privilege?.delivery?.action === 'manage'
              }
            />
            <Log code={data?.shipment?.id} order_id={data?.order?.id} />
          </div>
        </div>
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
